import React, { memo } from 'react';

import { Segmented } from 'antd';

import { Languages, LanguagesType } from 'context';

export interface ICvLanguagePicker {
  value: Languages;
  onChange: (language: Languages) => void;
}

/**
 * RUS / ENG / POL switcher for the CV text section and the PDF download
 * (spec 0018 §9 — Polish CV added).
 */
export const CvLanguagePicker = memo(({ value, onChange }: ICvLanguagePicker) => (
  <Segmented
    value={value}
    onChange={(next) => onChange(next as Languages)}
    options={[
      { value: Languages.russian, label: LanguagesType.RUS },
      { value: Languages.english, label: LanguagesType.ENG },
      { value: Languages.polish, label: LanguagesType.POL },
    ]}
  />
));
